import { render, staticRenderFns } from "./ColorsPaginatedAutocomplete.vue?vue&type=template&id=ffa63432&scoped=true&"
import script from "./ColorsPaginatedAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./ColorsPaginatedAutocomplete.vue?vue&type=script&lang=ts&"
import style0 from "./ColorsPaginatedAutocomplete.vue?vue&type=style&index=0&id=ffa63432&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa63432",
  null
  
)

export default component.exports